
import {
  Component,
  Prop,
  Vue,
  Watch
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { echartsJS } from "@/common/add-js";
@Component
export default class DevStatistics extends Vue {
  @Watch("initData")
  getVisible() {
    this.initEchart();
  }
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private initData!: objAny;
  private win: objAny = window;
  private chartsDiv: objAny = {
    chargeBox: ""
  };

  public initEchart(): void {
    this.$nextTick(() => {
      this.echartShow();
    });
  }
  async echartShow(): Promise<void> {
    await echartsJS();
    const seriesTop5DeviceNum = this.initData.seriesTop5DeviceNum;
    const arr: object[] = [];
    seriesTop5DeviceNum.map((item: objAny) => {
      arr.push({ value: item.itemValue, name: item.itemKey });
    });
    const option: objAny = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      color: ["#2d8cf0", "#19be6b", "#ff9900", "#ed4014", "#5cadff", "#2db7f5"],
      series: [
        {
          name: "设备TOP5",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "12"
            }
          },
          labelLine: {
            show: false
          },
          data: arr
        }
      ]
    };
    this.chartsDiv.chargeBox = this.win.echarts.init(this.$refs.echartTop);
    this.chartsDiv.chargeBox.clear();
    this.chartsDiv.chargeBox.setOption(option);
  }
  // mounted() {
  //   this.$nextTick(() => {
  //     this.echartShow();
  //   });
  // }
}
